import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from './useAuth';

// Hook: restituisce { isAdmin, role, loading } leggendo users/{uid}.role in real-time.
export function useIsAdmin() {
  const { user, loading: authLoading } = useAuth();
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authLoading) return;

    if (!user) {
      setRole(null);
      setLoading(false);
      return;
    }

    const ref = doc(db, 'users', user.uid);
    const unsub = onSnapshot(
      ref,
      (snap) => {
        setRole(snap.exists() ? snap.data().role || 'user' : null);
        setLoading(false);
      },
      (err) => {
        console.warn('useIsAdmin snapshot error:', err?.message || err);
        setRole(null);
        setLoading(false);
      }
    );

    return () => unsub();
  }, [user, authLoading]);

  return {
    isAdmin: role === 'admin',
    role,
    loading: authLoading || loading,
  };
}
